var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCloseWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landing-page_menu_mobile",
    transform: "translate(-352, -81)",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_close",
    transform: "translate(353, 82)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.166173952,15.8324157 C0.273360133,15.9397117 0.41880742,16 0.57047596,16 C0.7221445,16 0.867591787,15.9397117 0.974777968,15.8324157 L7.99791815,8.80989529 L15.0239156,15.8324157 C15.1683588,15.9768461 15.3788893,16.0332526 15.5762024,15.9803874 C15.7735155,15.9275222 15.9276345,15.7734167 15.9805044,15.5761211 C16.0333743,15.3788254 15.9769628,15.1683135 15.8325196,15.023883 L8.80652216,8.00136263 L15.8296623,0.975985251 C16.0529522,0.752715123 16.0529522,0.390722723 15.8296623,0.167452596 C15.6063725,-0.0558175319 15.2443482,-0.0558175319 15.0210583,0.167452596 L7.99791815,7.19282998 L0.97192071,0.170309602 C0.745191414,-0.0238392571 0.407215568,-0.0107858681 0.196139033,0.200272039 C-0.0149375012,0.411329945 -0.0279920423,0.749275964 0.166173952,0.975985251 L7.18931413,8.00136263 L0.166173952,15.02674 C-0.0553913173,15.2496079 -0.0553913173,15.6095478 0.166173952,15.8324157 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseWhite);
export default __webpack_public_path__ + "static/media/ic_close_white.1961835e3926889c5c3831f4ceb10892.svg";
export { ForwardRef as ReactComponent };